"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNLOAD_TYPE = exports.LOAD_TYPE = void 0;
var LOAD_TYPE = exports.LOAD_TYPE = 'Load Reducer Manager Type';
var UNLOAD_TYPE = exports.UNLOAD_TYPE = 'Unload Reducer Manager Type';
//# sourceMappingURL=actionTypes.js.map